// 问题管理页面
import { tkParse, tkDate } from '@moke/vue-tk'

export default {
  className: 'problemCheck',
  fields: [
    {
      name: 'problemClass',
      validators: [
        (value) => value ? null : '问题分类不可为空'
      ]
    },
    {
      name: 'proTitle',
      validators: [
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'user',
      note: '发布用户',
      listWhere: (where) => {
        where.authority = {
          $ne: 'administrator'
        }
      },
      validators: [
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'proImg'
    },
    {
      name: 'officialAnswer',
      validators: [
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'answerAudio'
    },
    {
      name: 'isHeat',
      note: '是否设为热度',
      width: 150
    },
    {
      name: 'readProblem',
      width: 150
    },
    {
      name: 'proStatus',
      width: 150
    }
  ],
  search: [
    'proTitle',
    'proStatus',
    {
      name: 'problemClass',
      validators: [
        (value) => value ? null : null
      ]
    }
  ],
  action: {
    edit: {
      text: '回复及审核'
    },
    delete: {
      type: 'row',
      text: '删除',
      callback: async ({ record, vm, className }) => {
        await vm.confirm('警告', '你确定要删除这条记录吗?')
        // 刪除此条商家信息
        let rs = await vm.$tkParse.put('/classes/' + className + '/' + record.objectId, { isDelete: true }).catch(() => {
          this.$notification['error']({
            message: '网络错误',
            description: '删除数据失败'
          })
        })
        if (rs) {
          vm.$notification['success']({
            message: '操作成功',
            description: ''
          })
          vm.refresh()
        }
      }
    }
  },
  hooks: {
    beforeFetch ({ where }) {
      where.isDelete = false
    },
    async beforeInsert ({ data }) {
      const res = await tkParse.get('/classes/_User', {
        params: {
          where: {
            objectId: data.user
          }
        }
      })
      // 如果创建用户时没有指明性别，则设为男性
      data.redStatus = 'wait'
      data.isDelete = false
      data.openId = res.data.results[0].openId
      if (!data.isHeat) { data.isHeat = false }
      if (!data.readProblem) { data.readProblem = 0 }
    },
    async beforeUpdate ({ data }) {
      if (!data.isHeat) { data.isHeat = false }
      if (!data.readProblem) { data.readProblem = 0 }
      console.log('数据', data)

      if (data.user) {
        console.log('进来了')
        let user = await tkParse.get(`/classes/_User/${data.user}`)
        if (user.data.wxToken) {
          await tkParse.post('/wx/sendMsg', {
            token: user.data.wxToken,
            first: data.officialAnswer,
            keyword1: data.proStatus === 'wait' ? '待审核' : data.proStatus === 'pass' ? '已通过' : '未通过',
            keyword2: tkDate(new Date()).format()
          })
        }
        console.log(user.data.wxToken)
      }
    }
  }
}
